export enum LoginState {
    LoggedOut,
    LoginRequest,
    LoggedIn,
    LoginFail,
    Registering,
    OTPRequired,
    RegisterSucess,
    RegisterFail
}